import { motion } from "framer-motion";

/**
 * Hero phone mockup — uses the real Coway "Accueil / Feed" screenshot.
 */
export default function PhoneMockup({ className = "" }) {
    return (
        <div className={`relative ${className}`} data-testid="phone-mockup">
            <motion.div
                animate={{ y: [0, -10, 0] }}
                transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
                className="relative mx-auto w-[260px] sm:w-[300px] lg:w-[320px] aspect-[9/19.5] rounded-[3rem] bg-slate-900 border border-slate-800 shadow-[0_40px_80px_-20px_rgba(15,23,42,0.25),0_0_120px_rgba(81,199,173,0.18)] overflow-hidden"
            >
                <div className="absolute top-3 left-1/2 -translate-x-1/2 w-28 h-6 bg-black rounded-full z-20 flex items-center justify-center gap-1.5">
                    <span className="w-1.5 h-1.5 rounded-full bg-coway/80" />
                </div>

                <div className="absolute inset-[6px] rounded-[2.7rem] overflow-hidden bg-white flex items-center justify-center">
                    <img
                        src="/screens/feed.jpeg"
                        alt="Application Coway — feed des trajets disponibles"
                        loading="eager"
                        className="w-full h-full object-contain object-center select-none pointer-events-none"
                        draggable={false}
                    />
                </div>
            </motion.div>

            {/* Floating trust badges */}
            <motion.div
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.6, duration: 0.6 }}
                className="absolute -left-4 sm:-left-10 top-16 px-3.5 py-2.5 rounded-2xl bg-white border border-slate-200 shadow-xl hidden sm:flex items-center gap-2"
                data-testid="badge-verified"
            >
                <span className="w-2 h-2 rounded-full bg-coway animate-pulse" />
                <span className="text-xs font-medium text-slate-900">
                    Profils vérifiés
                </span>
            </motion.div>

            <motion.div
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.8, duration: 0.6 }}
                className="absolute -right-4 sm:-right-10 bottom-24 px-3.5 py-2.5 rounded-2xl bg-white border border-slate-200 shadow-xl hidden sm:block"
                data-testid="badge-savings"
            >
                <p className="text-[10px] text-slate-500">Vous économisez</p>
                <p className="font-display font-black text-coway text-lg leading-none">
                    18,40 €
                </p>
            </motion.div>
        </div>
    );
}
